export default "__VITE_ASSET__3864d148__"